/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { HasContactDetails } from './HasContactDetails';
import type { Machine } from './Machine';
import type { PartImage } from './PartImage';

export type Manufacturer = {
  id: string;
  name: string;
  country: string;
  partfox_id: number;
  foundingYear: number | null;
  employeeCount: string | null;
  minPreferredQuantity: number | null;
  maxPreferredQuantity: number | null;
  search_events: number;
  contact_requests: number;
  rfq_interactions: number;
  partfox_uuid: string | null;
  membership_plan: string | null;
  materialIds: Array<string>;
  technologyIds: Array<string>;
  certificationIds: Array<string>;
  logoUrl: string | null;
  promotionalVideo: string | null;
  promotionalPdf: string | null;
  hero_images: Array<string>;
  availableCapacity: Manufacturer.availableCapacity;
  flags: Array<string>;
  machines: Array<Machine>;
  contactDetails: HasContactDetails;
  metrologyMachines: Array<Machine>;
  partImageObjects: Array<PartImage>;
  part_types: Array<'gear' | 'shaft' | 'screw' | 'tube' | 'tool'>;
  interactions: number;
  interactions_30: number;
  _score: number;
  _hiddenMachines: Array<string>;
};

export namespace Manufacturer {
  export enum availableCapacity {
    UNKNOWN = 'unknown',
    FREE = 'free',
    NONE = 'none',
  }
}
